import type React from "react";
import { Icon } from "../PaymentMethod/Icon";

interface PlusButtonProps {
  onClick: () => void;
}

export const PlusButton: React.FC<PlusButtonProps> = ({ onClick }) => {
  return (
    <button className="w-6 h-6 cursor-pointer" onClick={onClick} type="button">
      <Icon src="/assets/plus.svg" imageSize={{ width: "24", height: "24" }} />
    </button>
  );
};
